// Custom discovery events only. Shopify owns cart, checkout and purchase events.
(() => {
  if (window.__ortluxEvents) return;
  window.__ortluxEvents = true;
  const allowed = new Set(["select_product", "select_brand", "navigation", "contact_intent"]);
  const clean = (value) =>
    String(value || "")
      .replace(/[^a-z0-9_/-]/gi, "")
      .slice(0, 160);
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!link || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    const url = new URL(link.href, location.href);
    const productMatch = url.pathname.match(/\/products\/([a-z0-9-]+)$/i);
    const isBrand = /\/pages\/(duotts|ootd|onesport)$/.test(url.pathname);
    const name =
      link.dataset.ortluxEvent ||
      (productMatch
        ? "select_product"
        : isBrand
          ? "select_brand"
          : link.closest(".commerce-shell,footer")
            ? "navigation"
            : url.pathname.endsWith("/pages/contact")
              ? "contact_intent"
              : "");
    if (!allowed.has(name) || typeof Shopify.analytics?.publish !== "function") return;
    // No query strings, email addresses, input values or preview keys enter analytics.
    const payload = {
      version: 1,
      placement: clean(link.dataset.ortluxPlacement || link.closest("section")?.id || "content"),
      product_handle: clean(link.dataset.ortluxProduct || productMatch?.[1]),
      destination: clean(url.pathname),
      page_path: clean(location.pathname),
    };
    try {
      Promise.resolve(Shopify.analytics.publish("ortlux_" + name, payload)).catch(() => {});
    } catch (_) {
      /* Analytics failure must never prevent navigation. */
    }
  });
  if (window.Shopify?.loadFeatures && !Shopify.customerPrivacy) {
    Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {});
  }
})();
